import type { BolusActivity } from "@tandemdiabetes/sugarmate-api-react-client"
import { BolusState } from "@tandemdiabetes/sugarmate-api-react-client"
import { forwardRef } from "react"
import type {
  ComponentPropsWithoutRef,
  Ref,
} from "react"
import { usePolyglot } from "src/contexts"

interface Props extends ComponentPropsWithoutRef<"div"> {
  activity: BolusActivity;
}

export const BolusActivityMessage = forwardRef<HTMLDivElement, Props>(
  function BolusActivityMessage(props: Props, ref: Ref<HTMLDivElement>) {
    const {
      activity, ...htmlDivProps
    } = props

    const polyglot = usePolyglot()

    if (activity.state !== BolusState.InProgress) {
      return null
    }

    return (
      <div
        {...htmlDivProps}
        ref={ref}
      >
        {polyglot.t("components.activity_summary.message.bolus_in_progress")}
      </div>
    )
  },
)
